import phina from 'phina.js'
import config from '@/../package.json'

export default ()=>{

phina.define("TitleScene", {
  superClass : "MyDisplayScene",
  init : function(param) {
    // var self = this;
    this.superInit({width:1000,height:600,scale:param.scale});

    phina.display.Sprite('img/ui/bg.png')
    .setPosition(500,300)
    .addChildTo(this);

    phina.display.RectangleShape({
      width:1000, height:400,
      fill:'#FFF', stroke:'transparent',
    })
    .setPosition(500,300)
    .addChildTo(this);

    phina.display.Sprite('img/title.png')
    .setPosition(500,300)
    .setSize(600, 200)
    .addChildTo(this)
      .tweener
        .clear()
        .wait(1000)
        .fadeOut(1000);
    phina.display.Sprite('img/title2.png')
    .fromJSON({alpha:0})
    .setPosition(500,300)
    .setSize(600, 200)
    .addChildTo(this)
      .tweener
        .clear()
        .wait(2000)
        .fadeIn(2000);

    phina.display.Label({
      text:'(C) 2020 秋端てん ',
      fill:'#000', fontSize:16
    }).setPosition(500,585)
    .addChildTo(this)
    this.versionLabel = phina.display.Label({
      text:'version {0}'.format(config.version),
      fill:'#000', fontSize:18
    }).setPosition(900,590)
    .addChildTo(this)
  }
});

}